import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import TextView from "../components/TextView";
import PhotoView from "../components/PhotoView";
import WorkoutExerciseCountView from "../components/WorkoutExerciseCountView";
import WorkoutDetailView from "../components/WorkoutDetailView";
import LineView from "../components/LineView";
import RecordView from "../components/RecordView";
import AchievementView from "../components/AchievementView";
import AchievementDetailView from "../components/AchievementDetailView";
import Divider from "../components/Divider";
import achievementTypes from "../../../constants/achievement-types";
class WorkoutStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType, isModal) {
    super(story, me, viewType, isModal);
  }
  getStoryDate = () => {
    return this.story.story.log_date;
  };
  addContentViewModel = (parts, handler) => {
    let note = this.story.story.note;
    if (note && note.trim().length > 0) {
      parts.push({
        type: TextView,
        props: {
          text: note.trim(),
        },
        key: `note-${this.story.story_id}`,
      });
    }
    if (this.story.story.photo) {
      let photo = this.story.story.photo;
      parts.push({
        type: PhotoView,
        props: {
          photo: {
            id: photo.photo_id,
            h: photo.height,
            w: photo.width,
          },
          forWorkout: true,
          isModal: this.isModal,
        },
        key: `photo-${this.story.story_id}`,
      });
    }
    let workout = this.story.story.workout;
    if (workout.length > 0) {
      let note = this.story.story.note;
      parts.push({
        type: WorkoutDetailView,
        props: {
          workout: workout,
          handler: handler,
          achievements: this.story.story.achievements,
          note: note && note.trim().length > 0,
          isModal: this.isModal,
        },
        key: `wec-${this.story.story_id}`,
      });
    }
    if (workout.length > 0) {
      let last = parts[parts.length - 1];
      last.props.paddingBottom = 10;
    }
    let hasAchievemements = false;
    if (this.story.story.achievements.length > 0) {
      hasAchievemements = true;
    } else if (workout.length > 0) {
      for (let i = 0; i < workout.length; i++) {
        let exercise = workout[i];
        if (exercise.is_pr_rm || exercise.is_pr_vol) {
          hasAchievemements = true;
          break;
        }
      }
    }
    if (workout.length > 0 && hasAchievemements) {
      parts.push({
        type: AchievementDetailView,
        props: {
          workout: workout,
          achievements: this.story.story.achievements,
        },
        key: `acd-${this.story.story_id}`,
      });
    }
  };
}
export default WorkoutStoryViewModel;
